import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';
import { TimeSlotPicker, Translations } from '../../../../redux/types';
import { ClickOutside } from '../../../../utils/stencil/clickOutside';
import { trans } from '../../../../utils/trans';
import { CalendarMode } from '../utils';
import { DaysAvailability } from '../../../../types/types';

@Component({
  tag: 'rentware-date-expanded',
  styleUrl: 'style.sass',
  shadow: true,
})
export class rentwareDateExpanded {
  @Prop() calendarMode: CalendarMode = CalendarMode.SingleDayPickup; // For some minor mechanic
  @Prop() locale: string;
  @Prop() translations: Translations;
  @Prop() withTime: boolean;
  @Prop() withDateRange: boolean;
  @Prop() loadingPickUpHours: boolean;
  @Prop() loadingDropOffHours: boolean;
  @Prop() isLoading: boolean = false;
  @Prop() hasValidationError: boolean = false;
  @Prop() showNotAvailableOverlay: boolean;
  @Prop() onComponentLoaded: (any: any) => void;
  @Prop() onExpandedDidLoad: () => void;

  @Prop() monthAtStart: Date;
  @Prop() firstAvailableDate: Date;
  @Prop() lastAvailableDate: Date;
  @Prop() bookingDate: Date;
  @Prop() daysAvailability: DaysAvailability;
  @Prop() timeSlotPicker: TimeSlotPicker;
  @Prop() onDayClick: (day: Date) => void;
  @Prop() onMonthChange: (month: Date) => void;

  @Prop() bookingTimeHint: string;
  @Prop() bookingTime: string;
  @Prop() bookingHours: string[];
  @Prop() onBookingTimeChange: (time: string) => void;

  @Prop() endTimeHint: string;
  @Prop() endTime: string;
  @Prop() endHours: string[];
  @Prop() onEndTimeChange: (string) => void;
  @Prop() onResetCalendar: (day?: Date) => void;

  @Event() clickOutsideCalendar: EventEmitter;

  @ClickOutside()
  handleOutside({ target }) {
    this.clickOutsideCalendar.emit({ target });
  }

  componentWillLoad() {
    this.onComponentLoaded(rentwareDateExpanded.name);
  }

  componentDidLoad() {
    this.onExpandedDidLoad();
  }

  get timeSlotLabel() {
    return trans('articleBooking.timeSlotLabel', this.locale, this.translations);
  }

  get timeSlotHint() {
    return trans('articleBooking.timeSlotHint', this.locale, this.translations);
  }

  get pickUpLabel() {
    return trans('articleBooking.selectPickUpTimePlaceholder', this.locale, this.translations);
  }

  get dropOffLabel() {
    return trans('articleBooking.selectDropOffTimePlaceholder', this.locale, this.translations);
  }

  render() {
    return (
      <div class="DateExpandedInner">
        <rentware-range-picker
          calendarMode={this.calendarMode}
          monthAtStart={this.monthAtStart}
          locale={this.locale}
          onRangeDayClick={this.onDayClick}
          onRangeMonthClick={this.onMonthChange}
          firstAvailableDate={this.firstAvailableDate}
          lastAvailableDate={this.lastAvailableDate}
          withDateRange={false}
          rangeLoading={this.isLoading}
          daysAvailability={this.daysAvailability}
          bookingDate={this.bookingDate}
          autoClose={!this.withTime && !this.timeSlotPicker}
          showNotAvailableOverlay={this.showNotAvailableOverlay}
          onResetCalendar={this.onResetCalendar}
        />
        <rentware-spacer size="M" />

        {this.withTime && !this.timeSlotPicker && (
          <Fragment>
            <rentware-time-picker
              autoClose={this.withDateRange}
              hint={this.bookingTimeHint}
              value={this.bookingTime}
              options={this.bookingHours}
              disabled={!this.bookingDate}
              onTimeChange={this.onBookingTimeChange}
              isLoading={this.loadingPickUpHours}
              label={this.pickUpLabel}
            />

            <rentware-spacer size="M" />

            {!this.withDateRange && (
              <Fragment>
                <rentware-time-picker
                  autoClose={true}
                  hint={this.endTimeHint}
                  value={this.endTime}
                  options={this.endHours}
                  onTimeChange={this.onEndTimeChange}
                  disabled={!this.bookingDate}
                  isLoading={this.loadingDropOffHours}
                  label={this.dropOffLabel}
                />

                <rentware-spacer size="M" />
              </Fragment>
            )}
          </Fragment>
        )}
        {this.timeSlotPicker && (
          <Fragment>
            <rentware-time-picker
              autoClose={true}
              hint={this.timeSlotHint}
              label={this.timeSlotLabel}
              value={this.timeSlotPicker.selectedOption}
              optionsWithLabel={this.timeSlotPicker.options}
              onTimeChange={this.timeSlotPicker.onOptionChange}
              disabled={!this.bookingDate}
            />

            <rentware-spacer size="M" />
          </Fragment>
        )}
      </div>
    );
  }
}
